import { TimesheetScheduleMode } from 'app/constants/configuration/timesheetScheduleMode'

export const getTimesheetScheduleModeName = (
  timesheetScheduleMode: TimesheetScheduleMode,
  translate: (string) => string,
): string => {
  const text: string = TimesheetScheduleMode[timesheetScheduleMode]
  return translate(`timesheetScheduleMode.${text}`)
}
